/**
 * 前端报错包裹组件
 */
import React from "react";
class ErrorBoundary extends React.Component {
    state = {
        error: false 
    }

    static getDerivedStateFromError(error) {
        // 更新 state 使下一次渲染可以显示降级 UI
        return { error };
    }

    render() {
        if (this.state.error) {
            // 你可以渲染任何自定义的降级 UI
            return <div>{this.state.error.toString()}</div>;
        }

        return this.props.children;
    }
}
export default ErrorBoundary;
